//theme
import { homeColor } from '@/theme/ai';

//components
import {
  Kicker,
  KickerDot,
  SectionTitle,
  SectionLede,
  Grad,
} from '@/containers-ai/SectionHeading';

//styles
import {
  OpsGrid,
  Top100,
  Top100Big,
  Top100Small,
  Top100Copy,
  SectionCustom,
  ExpertsGrid,
  ExpertsBody,
  ExpertsPara,
  ExpertsNote,
  StatsTable,
  StatsRow,
  StatsValue,
} from './FreightExperts.styles';
import { Container } from '@/components/Grid';
import { CountUp } from '@/containers-ai/CountUp';

// With `stats`, the section drops the Top 100 badge and lists the platform
// numbers beside the copy instead (used on /ai/). Without it, the original
// layout renders unchanged (used on Home).
export function FreightExperts({ border = true, stats }) {
  if (stats) {
    return (
      <SectionCustom id="operators" border={border}>
        <Container>
          <ExpertsGrid>
            <div>
              <SectionTitle>
                Freight Experts, <Grad>on call.</Grad>
              </SectionTitle>
              <ExpertsBody>
                Every other AI automates the easy part and hands the hard part
                back to you. Our Freight Experts take on the hard part. You get
                the results. Nothing else.
              </ExpertsBody>
              <ExpertsPara>
                <b>Our Freight Experts move real freight every day.</b> They
                bring 230k+ carrier relationships and more than a decade of
                industry expertise to finish what software starts.
              </ExpertsPara>
              <ExpertsNote>
                Ranked in the Transport Topics Top 100 freight brokerage firms.
              </ExpertsNote>
            </div>
            <StatsTable>
              {stats.map((stat) => (
                <StatsRow key={stat.label}>
                  {stat.label.charAt(0).toUpperCase() + stat.label.slice(1)}
                  <StatsValue>
                    <CountUp value={stat.value} />
                    {stat.unit}
                  </StatsValue>
                </StatsRow>
              ))}
            </StatsTable>
          </ExpertsGrid>
        </Container>
      </SectionCustom>
    );
  }

  return (
    <SectionCustom id="operators" border={border}>
      <Container>
        <OpsGrid>
          <div>
            <Kicker color={homeColor.amber}>
              <KickerDot color={homeColor.amber} />
              When you need humans
            </Kicker>
            <SectionTitle>
              Freight Experts, <Grad>on call.</Grad>
            </SectionTitle>
            <SectionLede>
              Every other AI automates the easy part and hands the hard part
              back to you. Our Freight Experts take on the hard part. You get
              the results. Nothing else.
            </SectionLede>
          </div>
          <Top100>
            <div>
              <Top100Big>Top 100</Top100Big>
              <Top100Small>
                Transport Topics
                <br />
                Freight Brokerage Firm
              </Top100Small>
            </div>
            <Top100Copy>
              <b>Our Freight Experts move real freight every day.</b> They bring
              230k+ carrier relationships and more than a decade of industry
              expertise to finish what software starts.
            </Top100Copy>
          </Top100>
        </OpsGrid>
      </Container>
    </SectionCustom>
  );
}
